export enum SlackChannel {
    DEVELOPMENT = 'development',
    SYSTEM = 'system',
    CRITICAL = 'critical_alerts',
}

export enum AlertSeverity {
    CRITICAL = 'critical',
    MAJOR = 'major',
    MINOR = 'minor',
    WARNING = 'warning',
    INFO = 'info',
}

export enum ChangeLogsEntityEnum {
    INVOICE = 'invoice',
    CLIENT = 'client',
    SUBSCRIPTION = 'subscription',
}

export enum LeadStatus {
    NEW = 'New', // Lead has been created but not yet contacted or qualified
    CONTACT_ATTEMPTED = 'Contact Attempted', // An attempt to contact the lead has been made but no response yet
    CONTACTED = 'Contacted', // Lead has been contacted and is being worked on
    PROSPECTING = 'Prospecting', // Actively exploring requirements and building relationship
    NEGOTIATING = 'Negotiating', // Discussing terms, pricing, or specific parking arrangements
    CONVERTED = 'Converted', // A parking subscription has been created
    CLOSED = 'Closed', // Lead will no longer be pursued actively by a person - Depending on the reason below, it may be moved to an automated process
}

export enum LeadClosedReason {
    NO_AVAILABILITY = 'No Availability in Area', // Likely to be emailed if parking comes to that area
    NO_RESPONSE = 'No Response', // Likely to be SMSed and emailed and will be marked as open again if there is any engagement
    DUPLICATE = 'Duplicate', // Ignore
    BUDGET_CONSTRAINTS = 'Budget Constraints', // Likely to be emailed
    TIMING_ISSUES = 'Timing Issues', // Likely to be emailed
    CHOSE_COMPETITOR = 'Chose Competitor', // Likely to be emailed
    OTHER = 'Other',
    MANUALLY_CLOSED_OLD_LEAD = 'Manually Closed - Old Lead',
}

export enum ContactType {
    USER = 'User', // Regular user who signed up through the website
    LEAD = 'Lead', // Manually created lead
    LANDLORD = 'Landlord', // Property owner/landlord
}

export enum LeadCity {
    JOHANNESBURG = 'Johannesburg',
    CAPE_TOWN = 'Cape Town',
    DURBAN = 'Durban',
    PRETORIA = 'Pretoria',
    PORT_ELIZABETH = 'Port Elizabeth',
    BLOEMFONTEIN = 'Bloemfontein',
    EAST_LONDON = 'East London',
    NELSPRUIT = 'Nelspruit',
    KIMBERLEY = 'Kimberley',
    POLOKWANE = 'Polokwane',
    RUSTENBURG = 'Rustenburg',
}

export enum BroadLocation {
    CAPE_TOWN = 'Cape Town',
    JOHANNESBURG = 'Johannesburg',
    PRETORIA = 'Pretoria',
    DURBAN = 'Durban',
    GQEBERHA = 'Gqeberha',
    BLOEMFONTEIN = 'Bloemfontein',
    EAST_LONDON = 'East London',
    NELSPRUIT = 'Nelspruit',
    KIMBERLEY = 'Kimberley',
    POLOKWANE = 'Polokwane',
    RUSTENBURG = 'Rustenburg',
    OTHER = 'Other',
}

export enum PopupMode {
    CHOOSE_CARD = 'chooseCard',
    ADD_CARD = 'addCard',
    OTP_SECURE = 'otpSecure',
    COMPLETE = 'complete',
    HOW_IT_WORKS = 'howItWorks',
}

export enum DashboardMetric {
    SUBSCRIPTION_FUTURE_VALUE = 'subscriptionFutureValue',
    SUBSCRIPTIONS_TOTAL = 'subscriptionsTotal',
    SUBSCRIPTIONS_PAYFAST = 'subscriptionsPayfast',
    SUBSCRIPTIONS_PAYGATE = 'subscriptionsPaygate',
    SUBSCRIPTIONS_EFT = 'subscriptionsEft',
    BAYS_TOTAL = 'baysTotal',
    BAYS_ACTIVE = 'baysActive',
    BAYS_CAPACITY = 'baysCapacity',
    BUILDINGS_TOTAL = 'buildingsTotal',
    BUILDINGS_UNPUBLISHED = 'buildingsUnpublished',
    BUILDINGS_ACTIVE = 'buildingsActive',
    INVOICES_OVERDUE_TOTAL = 'invoicesOverdueTotal',
    INVOICES_OVERDUE_COUNT = 'invoicesOverdueCount',
    INVOICES_NOT_PAID_OUT_TOTAL = 'invoicesNotPaidOutTotal',
    INVOICES_NOT_PAID_OUT_COUNT = 'invoicesNotPaidOutCount',
    USERS = 'users',
    USERS_WITH_PROFILE = 'usersWithProfile',
    USERS_ACTIVE = 'usersActive',
    USERS_NEW = 'usersNew',
    USERS_NEW_WITH_PROFILE = 'usersNewWithProfile',
    SUBSCRIPTIONS_NEW_COUNT = 'subscriptionsNewCount',
    SUBSCRIPTIONS_NEW_VALUE = 'subscriptionsNewValue',
}

export enum SubscriptionType {
    PAYFAST = 'payfast',
    EFT = 'eft',
    PAYGATE = 'paygate',
    // Delete these
    BILLABLE = 'billable',
    MANUAL = 'manual',
}

export enum WatiTemplates {
    MERCHANT_PARKING_REQUEST_CREATED = 'merchant_parking_request_created_v5',
    CLIENT_RENEWAL_5_REMINDER = 'client_contract_ending_5_reminder',
    CLIENT_RENEWAL_1_REMINDER = 'client_contract_ending_1_reminder',
    MERCHANT_PARKING_REQUEST_CREATED_REMINDER = 'merchant_parking_request_created_v2_merchant_parking_request_reminder',
    CLIENT_PARKING_REQUEST_ACCEPTED = 'parker_request_accepted_v4',
    BOOKUPP_CLIENT_BOOKING_CREATED = 'parker_booking_created_10',
    BOOKUPP_MERCHANT_TENANT_ACCEPTED = 'merchant_tenant_accepted_7',
    REVIEW_REQUEST = 'review_request_2',
    PARKING_NOT_FOUND_REQUEST = 'parking_not_found_request_2',
    CRM_NO_ANSWER = 'crm_no_answer_2',
    CRM_GOOGLE_REVIEW = 'google_review_v2',
    CRM_NEW_SUBSCRIPTION_CONFIRMATION = 'enter_a_newparkingsub_on_behalf_of_parkerv2',
    SECURITY_NEW_CONTRACT = 'security_new_contract',
    SECURITY_ENDED_CONTRACT = 'security_ended_contract',
}


export enum PayoutBatchStatusEnum {
    DUE = 'due',
    PAID = 'paid',
    DELETED = 'deleted',
}

export enum PayoutStatusEnum {
    DUE = 'due',
    BATCHED = 'batched',
    PAID = 'paid',
    DELETED = 'deleted',
}

export enum NonRenewalReason {
    FOUND_ALTERNATIVE = 'Found Alternative Parking',
    TOO_EXPENSIVE = 'Too Expensive',
    NO_LONGER_NEEDED = 'No Longer Needs Parking',
    RELOCATED = 'Relocated',
    POOR_EXPERIENCE = 'Poor Experience',
    OTHER = 'Other',
}

export enum CampaignSource {
    FACEBOOK = 'Facebook',
    INSTAGRAM = 'Instagram',
    META = 'Meta',
    TIKTOK = 'TikTok',
    TWITTER = 'Twitter',
    LINKEDIN = 'LinkedIn',
    GOOGLE = 'Google',
    EMAIL = 'Email',
    SENDGRID = 'SendGrid',
    DIRECT = 'Direct',
    REFERRAL = 'Referral',
    AFFILIATE = 'Affiliate',
    CLUSTER = 'Cluster',
    OTHER = 'Other',
    YOUTUBE = 'YouTube',
    GOOGLE_ADS = 'Google Ads',
}
